import React from 'react';
// Original imports preserved for future reactivation — intentionally unused.
// eslint-disable-next-line no-unused-vars
import { useState, useEffect, useContext, useCallback } from 'react';
// eslint-disable-next-line no-unused-vars
import { useNavigate } from 'react-router-dom';
// eslint-disable-next-line no-unused-vars
import { AuthContext } from '../App';
// eslint-disable-next-line no-unused-vars
import axios from 'axios';
// eslint-disable-next-line no-unused-vars
import { MessageSquare, X, AlertTriangle } from 'lucide-react';
// eslint-disable-next-line no-unused-vars
import { Button } from './ui/button';

// eslint-disable-next-line no-unused-vars
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// eslint-disable-next-line no-unused-vars
const API = BACKEND_URL;

// Entry point hidden pre-deploy — destination route /beta/feedback has been
// unrouted. Component preserved on disk; it simply renders nothing now.
// The full original implementation is retained verbatim below (commented) for
// future reactivation without any copy changes.
// eslint-disable-next-line no-unused-vars
export default function FeedbackReminder({ compact = false }) {
  return null;
}

/*
  Archived original implementation — intentionally inert.

  export default function FeedbackReminder({ compact = false }) {
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);
    const [betaStatus, setBetaStatus] = useState(null);
    const [dismissed, setDismissed] = useState(false);

    const fetchBetaStatus = useCallback(async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API}/api/beta/status`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setBetaStatus(response.data);
      } catch (error) {
        console.error('Error fetching beta status:', error);
      }
    }, []);

    useEffect(() => {
      if (user) {
        fetchBetaStatus();
      }
    }, [user, fetchBetaStatus]);

    // Don't show if not a beta tester or if dismissed
    if (!betaStatus?.is_beta_tester || dismissed) return null;

    const needsFeedback = betaStatus.feedbacks_this_month < betaStatus.feedbacks_required_monthly;
    const feedbacksNeeded = betaStatus.feedbacks_required_monthly - betaStatus.feedbacks_this_month;

    // Compact version for sidebar/nav
    if (compact) {
      return (
        <button
          onClick={() => navigate('/beta/feedback')}
          className={'w-full p-3 rounded-xl border-2 transition-all text-left ' + (
            needsFeedback
              ? 'border-amber-400 bg-amber-50 hover:bg-amber-100'
              : 'border-emerald-400 bg-emerald-50 hover:bg-emerald-100'
          )}
        >
          <div className="flex items-center gap-2">
            <MessageSquare className={'w-4 h-4 ' + (needsFeedback ? 'text-amber-600' : 'text-emerald-600')} />
            <span className="text-sm font-medium">
              {needsFeedback ? (feedbacksNeeded + ' feedback needed') : '✓ Monthly feedback done'}
            </span>
          </div>
          <div className="mt-1 flex items-center gap-2">
            <div className="flex-1 bg-slate-200 rounded-full h-1.5">
              <div
                className={'h-full rounded-full ' + (needsFeedback ? 'bg-amber-500' : 'bg-emerald-500')}
                style={{ width: (Math.min(100, (betaStatus.feedbacks_this_month / betaStatus.feedbacks_required_monthly) * 100)) + '%' }}
              />
            </div>
            <span className="text-xs text-slate-500">
              {betaStatus.feedbacks_this_month}/{betaStatus.feedbacks_required_monthly}
            </span>
          </div>
        </button>
      );
    }

    // Full banner version
    if (!needsFeedback) return null;

    return (
      <div className="bg-amber-50 border-2 border-amber-400 rounded-xl p-4 relative">
        <button
          onClick={() => setDismissed(true)}
          className="absolute top-2 right-2 text-amber-600 hover:text-amber-800"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-start gap-3">
          <div className="bg-amber-100 p-2 rounded-full">
            <AlertTriangle className="w-5 h-5 text-amber-600" />
          </div>
          <div className="flex-1">
            <h4 className="font-bold text-amber-900">Feedback Reminder</h4>
            <p className="text-sm text-amber-700 mt-1">
              You need {feedbacksNeeded} more feedback{feedbacksNeeded > 1 ? 's' : ''} this month to maintain your beta tester status.
            </p>
            <div className="mt-3 flex items-center gap-3">
              <Button
                size="sm"
                onClick={() => navigate('/beta/feedback')}
                className="bg-amber-500 hover:bg-amber-600 text-white border border-amber-700 rounded-full"
              >
                <MessageSquare className="w-4 h-4 mr-1" />
                Give Feedback
              </Button>
              <span className="text-xs text-amber-600">
                {betaStatus.days_remaining} days left in your beta period
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
*/
